module.exports = __webpack_public_path__ + "img/bg-1.4547da35.jpg";